import React, { Suspense } from "react";

export const LazyArticlePage: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <LazyArticlePageBase />
    </Suspense>
  );
};

const LazyArticlePageBase = React.lazy<React.ComponentType>(() =>
  import(/* webpackChunkName: "article-page" */ "./ArticlePage").then(
    (module) => {
      return {
        default: module.ArticlePage,
      };
    }
  )
);
